var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav-bar"},[_c('main',{staticClass:"maxW"},_vm._l((_vm.navList),function(item){return _c('div',{key:item.path,on:{"click":function($event){return _vm.goToPath(item.path)}}},[_vm._v(_vm._s(item.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }